<template>

	<div class="lobby-index">

		<div class="container pb20">


			<div class="col-md-4">
				<IndexLeader/>
			</div>

			<div class="col-md-8">


        <div class="row">
          <div class="col-md-6">
            <IndexVideo type="COURSE"/>
          </div>
          <div class="col-md-6">
            <IndexVideo type="LECTURE"/>
          </div>
        </div>

				<div class="row mt10">

					<div class="col-md-6">

						<IndexCourseCenter/>

					</div>

					<div class="col-md-6">

						<IndexGarden/>


					</div>
				</div>



			</div>

		</div>

	</div>

</template>
<script>


	import IndexLeader from "./widget/IndexLeader.vue";
	import IndexGarden from "./widget/IndexGarden.vue";
	import IndexCourseCenter from "./widget/IndexCourseCenter.vue";
	import IndexVideo from "./widget/IndexVideo.vue";
	import Pager from "../../../../common/model/base/Pager";
	import ItemBlock from "../../theme/widget/ItemBlock.vue";

	import Block from '../../../../common/model/lover/theme/Block'
	import Item from '../../../../common/model/lover/theme/Item'

	export default {

		data () {
			return {

				blocks: []
			}
		},
		computed: {
			topic(){
				return this.$route.meta.topic;
			}
		},
		watch: {},
		components: {
			IndexLeader,
			IndexGarden,
			IndexCourseCenter,
			IndexVideo,
			ItemBlock
		},
		methods: {
			refresh(){

			}
		},
		created(){


		},
		mounted(){


			//从topic中将Block提取出来。
			let arr = JSON.parse(this.topic.remark);
			if (arr instanceof Array) {

				//首先清空现有的。
				this.blocks.splice(0, this.blocks.length);
				for (let i = 0; i < arr.length; i++) {
					let obj = arr[i];
					let block = new Block();
					block.render(obj);
					this.blocks.push(block);
				}

			}

		}
	}
</script>

<style lang="less" rel="stylesheet/less">

	@import "../../../../common/assets/css/global/variables";

	.lobby-index {

		margin-top: 15px;

		.index-title-block {
			//border-bottom: 1px solid #bbbbbb;

			.index-title {
				font-size: 18px;
				padding: 3px 0 5px;
				border-left: none;
				color: @secondary-color;
				line-height: 30px;
				font-weight: bold;

			}
			.index-title-more {
				padding-top: 10px;
			}

		}

		.index-content-block {
			background-color: white;
			padding: 20px;

			p {
				padding: 0;
				margin: 0;
			}

		}

		a {
			cursor: pointer;
			color: #555;

			&:hover {
				color: blue;
				text-decoration: underline;
			}
		}

	}


</style>




// WEBPACK FOOTER //
// SceneryIndex.vue?10356313